'use client';
import { styled } from '@mui/material/styles';
import isPropValid from '@emotion/is-prop-valid';

interface SectionProps {
  order?: number;
  portraitHeight?: number;
  landscapeHeight?: number;
}

export const Section = styled('section', {
  shouldForwardProp: isPropValid,
})<SectionProps>(
  ({ order, landscapeHeight, portraitHeight }) => `
    z-index: ${order ?? 'initial'};
    background: #101010;
    position: relative;
    width: 100%;
    overflow: visible;
    visibility: visible;
    pointer-events: all;

    @media (orientation: landscape) {
      height: ${landscapeHeight ?? 0}vh;
    }

    @media (orientation: portrait) {
      height: ${portraitHeight ?? 0}vh;
    }
  `,
);

const Root = styled('div')`
  top: 0;
  height: 100vh;
  width: 100%;
`;

export const Fixed = styled(Root)`
  position: fixed;
  pointer-events: none;
`;

export const Absolute = styled(Root)`
  position: absolute;
`;

export const CanvasContainer = styled('div')`
  position: relative;
  overflow: hidden;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  & > canvas {
    position: absolute;
    height: 100vh;
    width: 100vw;
    min-width: 100vw;
    transform-origin: top;
    object-fit: cover;
  }
`;

export const SectionContent = styled('div')`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  margin-left: auto;
  margin-right: auto;
  max-width: 520px;
  top: -65px;
  z-index: 2;
`;

export const CopyWrapper = styled('div')`
  z-index: 1;
  text-align: center;
  width: 100%;
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;

  & > h1,
  & > span,
  & > h4 {
    color: #f7f7f7;
    font-family: 'Knockout-Banner', sans-serif;
    line-height: 0.8;
    font-weight: normal;
    text-transform: uppercase;
  }

  & > h1 {
    font-size: clamp(5rem, 3.4694rem + 6.5306vw, 10rem);
    font-weight: bold;
  }

  & > span {
    font-size: clamp(1.5rem, 1.3469rem + 0.6531vw, 2rem);
    letter-spacing: 2px;
  }

  & > h4 {
    font-size: clamp(3rem, 2.3878rem + 2.6122vw, 5rem);
  }

  & > hr {
    height: 0.25rem;
    width: 3rem;
    display: block;
    margin-top: 1.5rem;
    margin-left: auto;
    margin-right: auto;
    background-color: #d95e16;
  }

  & > p {
    color: #f7f7f7;
    font-size: clamp(1rem, 0.8852rem + 0.4898vw, 1.375rem);
    line-height: 1.82;
    font-family: 'Roboto', sans-serif;
    margin-bottom: 40px;
  }
`;
